const TIPOS = [
    { slug: "pago", label: "Pago" },
    { slug: "regimental", label: "Gratuidade Regimental" },
    { slug: "nao_regimental", label: "Gratuidade Não-Regimental" },
];

const LABELS = TIPOS.map((t) => t.label);

function zeroIndicadores() {
    return {
        matricula_regimental: 0,
        matricula_nao_regimental: 0,
        matricula_pago: 0,
        hora_regimental: 0,
        hora_nao_regimental: 0,
        hora_pago: 0,
    };
}

export default { TIPOS, LABELS, zeroIndicadores };
